// components/home/Features/styles.js
import styled from "styled-components";
import { motion } from "framer-motion";
import { Container } from "../../../styles/components";

export const FeaturesWrapper = styled.section`
	padding: ${(props) => `${props.theme.spacing["4xl"]} 0`};
	background: ${(props) => props.theme.colors.background.main};
`;

export const FeaturesContainer = styled(Container)`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const SectionHeader = styled(motion.div)`
	text-align: center;
	max-width: 700px;
	margin-bottom: ${(props) => props.theme.spacing["3xl"]};

	h2 {
		font-size: ${(props) => props.theme.typography.sizes["3xl"]};
		font-weight: ${(props) => props.theme.typography.weights.bold};
		color: ${(props) => props.theme.colors.text.primary};
		margin-bottom: ${(props) => props.theme.spacing.md};
	}

	p {
		font-size: ${(props) => props.theme.typography.sizes.lg};
		color: ${(props) => props.theme.colors.text.secondary};
	}
`;

export const FeaturesGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(1, 1fr);
	gap: ${(props) => props.theme.spacing.xl};
	width: 100%;

	@media (min-width: ${(props) => props.theme.breakpoints.sm}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (min-width: ${(props) => props.theme.breakpoints.lg}) {
		grid-template-columns: repeat(3, 1fr);
	}
`;

export const FeatureCard = styled(motion.div)`
	background: ${(props) => props.theme.colors.background.alt};
	border-radius: ${(props) => props.theme.borderRadius.lg};
	padding: ${(props) => props.theme.spacing.xl};
	transition: transform ${(props) => props.theme.transitions.normal};
	height: 100%;

	&:hover {
		transform: translateY(-4px);
	}
`;

export const IconWrapper = styled.div`
	width: 48px;
	height: 48px;
	border-radius: ${(props) => props.theme.borderRadius.lg};
	background: ${(props) => props.theme.colors.primary.main}15;
	color: ${(props) => props.theme.colors.primary.main};
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: ${(props) => props.theme.spacing.lg};
`;

export const FeatureTitle = styled.h3`
	font-size: ${(props) => props.theme.typography.sizes.xl};
	font-weight: ${(props) => props.theme.typography.weights.semibold};
	color: ${(props) => props.theme.colors.text.primary};
	margin-bottom: ${(props) => props.theme.spacing.md};
`;

export const FeatureDescription = styled.p`
	font-size: ${(props) => props.theme.typography.sizes.md};
	color: ${(props) => props.theme.colors.text.secondary};
	line-height: ${(props) => props.theme.typography.lineHeights.relaxed};
`;
